import React, { Component, Fragment } from 'react';
import {Helmet} from "react-helmet";
import ReactGA from 'react-ga';
// import LazyLoad from 'react-lazyload';
import NavTop from '../../containers/NavTop/NavTop';
import MarketGrowthSection from '../../containers/MarketGrowthSection/MarketGrowthSection';
import ApplicationCard from '../../common/Cards/ApplicationCard/ApplicationCard';
import './ApplicationsPage.css';
import {BackTop} from 'antd';
import ApplicationHeader from '../../containers/ApplicationHeader/ApplicationHeader';


class ApplicationsPage extends Component {

  constructor(props){
    super(props);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  
  componentWillMount(){
    // let {pageOn} = this.props;
    // console.log(pageOn);
  }

  render(){
    return(
      <Fragment>
        <Helmet>
            <meta charSet="utf-8" />
            <title>RealTimeTouch.com - Applications &amp; Use Cases</title>
            <link rel="canonical" href="http://www.realtimetouch.com/applications/" />
        </Helmet>
        <NavTop pageOn={this.props.pageOn}/>
        <BackTop />
          {/* <AlertSection />
          <NavTop /> */}
        <div className="ApplicationsPage--container-header center">
         <ApplicationHeader />
        </div>
        
        <div className="ApplicationPage--subnavbar-container">
          <div className="ApplicationPage--subnavbar center">
          </div>  
          <div className="ApplicationPage--subnavbar2 center">
          </div>
          <h2 className="ApplicationsPage--subnavbar-headline font-special-heading">Applications &amp; Use Cases</h2>
        </div>

        <div className="ApplicationsPage--headline-container">
            <h2 className="ApplicationsPage--headline">Real Time Touch has many promising applications.</h2>
            <h4 className="ApplicationsPage--subheadline">Real Time Touch envisions applications in a variety of fields including:</h4>
            <p className="ApplicationsPage--body center"> 
            <ul className="ApplicationPage--list-app">
              <li>Remote and local diagnosis and vital signs reports for doctor, nurse, and patient</li>
              <li>Medicine release, medication adherence verification, and monitoring, real time video physical therapies</li>
              <li>Testing reflexes and stretching enhanced with real-time physical interaction</li>
              <li>Even Real time physical treatments and medicine deliveries to soldiers in the field and patients in rural communities</li>
            </ul>
            </p>
       </div> 

            <ApplicationCard pick="Rural" /> 
            <ApplicationCard pick="Law-Enforcement" />
            <ApplicationCard pick="Telepsychiatry" />
            <ApplicationCard pick="Humanitarian" />
              <ApplicationCard pick="Remote-Workers" />
              <ApplicationCard pick="Military" />
              <ApplicationCard pick="Remote-Diagnostics" />
              <ApplicationCard pick="Drone" />   
              <ApplicationCard pick="Global-Network" />
              <ApplicationCard pick="Fire-Stations" />
    
                 
            <MarketGrowthSection />
      </Fragment>
    )
  }
}


export default ApplicationsPage;




// WEBPACK FOOTER //
// ./src/pages/ApplicationsPage/ApplicationsPage.js